import emptyPng from 'common/components/res/empty.png';

const defaults = { alt: 'kellis empty state', src: emptyPng };
export default () => {
  return <View as="img" wp={10} maxw={300} asProps={defaults} />;
};
